import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
// import thumbnailImg from '../../assets/images/landingpage/Hero-thumbnail.avif';
import { Link } from 'react-router-dom';
import * as Icons from '../../common/icons/homePageIcons';

const HeaderBanner = (props) => {
    const [loadVideo, setLoadVideo] = useState(false);
    const bannerData = props?.data;
    const bannerBgImg = props?.bannerImg;
    const Icon = Icons[bannerData?.btnIcon] || null;
    useEffect(() => {
        const timer = setTimeout(() => {
            setLoadVideo(true);
        }, 2000);

        return () => clearTimeout(timer);
    }, []);
    // function myFunction() {
    //     document.getElementById("mp4_src").src = bannerBgImg;
    //     document.getElementById("myVideo").load();
    // }
    // useEffect(() => {
    //     myFunction();
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [])
    if (!bannerData) return null; // prevents shift from async data



    return (
        <div className="static-slider-head">
            {/* <video
                id="myVideo"
                loop
                autoplay
                playsinline
                preload="metadata"
                poster="/assets/images/landingpage/Hero-thumbnail.avif"
                class="w-100"
                fetchpriority="high"
                aria-hidden="true"
            > */}
            {!loadVideo ? (
                <img
                    src="/assets/images/landingpage/Hero-thumbnail.avif"
                    alt="Hero"
                    fetchpriority="high"
                />
            ) : (
                <video
                    id="myVideo"
                    loop
                    muted
                    autoPlay
                    playsInline
                    preload="metadata"
                    poster={'/assets/images/landingpage/Hero-thumbnail.avif'}
                    className='w-100'
                    fetchpriority="high"
                    aria-hidden="true"
                >
                    {loadVideo && (
                        <source id="mp4_src" src={bannerBgImg} type="video/mp4" />
                    )}
                    Your browser does not support HTML5 video.
                </video>
            )}

            <Container className="static-container">
                <Row className="justify-content-start">
                    <Col lg="8" md="6" className="align-self-start">
                        <h1>{bannerData?.title} <span>{bannerData?.subTitle}</span> {bannerData?.subTitle2}</h1>
                        <p>{bannerData?.text}</p>
                        <Link to={bannerData?.link} className="btn btn-md m-t-30 btn-info-gradiant font-14 rounded-5">
                            {bannerData?.btnName} {Icon && <Icon />}
                        </Link>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default HeaderBanner;
